import { EN_TENANT_NAME } from '../../enums/tenant';
import { registerPlugin } from '../../plugins/plugin_register';
import { DefaultRegistry } from '../default_registry';
import { registerTenantConfig } from '../register';

@registerTenantConfig(EN_TENANT_NAME.欧莱雅)
export class 欧莱雅TenantRegistry extends DefaultRegistry {
  static async register(): Promise<void> {
    super.register();
    const { UIConfig2 } = await import('../../plugins/service_plugins/ui_config/ui_config2');
    registerPlugin(UIConfig2);
  }
}
